import React, { useContext, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination } from 'swiper/modules';
import { NavLink } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import './HeaderSlider.css';
import { HomeContext } from '../../Context/HomeContext';
import Loader from '../Loader';

const HeaderSlider = () => {
  const { homeData } = useContext(HomeContext);
  const sliderBlogs = homeData?.headerSliderBlogs || [];
  const [initialSlideIndex, setInitialSlideIndex] = useState(2);

  if (!sliderBlogs.length) {
    return <Loader text="Loading ..." />;
  }

  return (
    <div className="coverflow-slider-container">
      <Swiper
        effect="coverflow"
        grabCursor={true}
        centeredSlides={true}
        loop={false}
        initialSlide={initialSlideIndex}
        slidesPerView="auto"
        pagination={{ clickable: true }}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 2.5,
          slideShadows: false,
        }}
        modules={[EffectCoverflow, Pagination]}
        className="coverflow-swiper"
      >
        {sliderBlogs.map((blog) => (
          <SwiperSlide key={blog.id} className="coverflow-slide">
            <NavLink to={`/blog/${blog.slug}`} className="card-link-wrapper">
              <div className="card">
                <img
                  src={`https://api.funfillia.com/${blog.image_500x500}`}
                  alt={blog.title}
                />
                <div className="card-body">
                  <h5>{blog.title}</h5>
                  <p>{blog.short_description?.slice(0, 80) || blog.title}</p>
                </div>
              </div>
            </NavLink>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HeaderSlider;
